// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as CardsOutlineComponent} from './CardsOutline.svg';

import Icon, { TIconProps } from '../Icon';

export const IconCardsOutline = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <CardsOutlineComponent/>
  </Icon>
));
